import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import { BillingCashFlowResponse } from './types';

export interface UseGetBillingCashFlowParams {
	month?: number;
	year?: number;
}

export function useGetBillingCashFlow({ month, year }: UseGetBillingCashFlowParams = {}) {
	return useQuery<BillingCashFlowResponse>({
		queryKey: ['billing-cash-flow', month, year],
		queryFn: async () => {
			const { data } = await api.get<BillingCashFlowResponse>('/invoicing/cash-flow', {
				params: { month, year },
			});
			return data;
		},
	});
}
